import axios from "axios";
// import { useUserInfo } from "hooks/common";
import { ToastMsg, InitStorage} from 'utils/commonUtil';
import Cookies from 'js-cookie';

const WHITE_API = ["/loginProcess","/MOD-RESETPASSWORD-INFO", 
  "/ADD-SIGNUP-INFO", "/DIS-IDCHECK-LIST", "/DIS-CODE-LIST"];
const instance = axios.create({
  baseURL: process.env.REACT_APP_URL,
  timeout: 1000 * 10,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true,
});

instance.interceptors.request.use(
  (config) => {
    const { url } = config;
    // is white list
    if (!WHITE_API.includes(url)) {
      // no white list auth
        config.headers = {
          ...config.headers,
          "X-XSRF-TOKEN" : getCookie("XSRF-TOKEN"),
          "Authorization": getCookie("jwt"),
        };
    }
    
    
  if( window.location.pathname === "/"){
    config.headers = {
      ...config.headers,
    };
  }
    return config;
  },
  (error) => {
    window.location.href = "/error/500";
    return Promise.reject(error);
  }
  
);

instance.interceptors.response.use(
  (response) => {
    const { data } = response;

    //jwt 에러시 반환받을 값
    if(data?.length > 8 && data?.substring(0, 8) === 'JWTERROR'){
      if(window.location.pathname !== '/') {
        setTimeout(() => {
          const allCookies = Cookies.get();
          Object.keys(allCookies).forEach(cookieName => {
            Cookies.remove(cookieName);
          });
          window.location.href = "/";
          const expiresIn5Seconds = new Date(new Date().getTime() + 5 * 1000);
          Cookies.set('expired', 'expired', { expires: expiresIn5Seconds });
        }, 70); 
      }
    }

    if (process.env.REACT_APP_LOG === "1") {
      console.log(data?.addition?.cmdName || '', data);
    }

    return data || response;
  },
  (error) => {
    console.log("error:", error.response);
    if (WHITE_API.includes(error?.config?.url || '')) {
      return error;
    }
    if(error.response) {
      const { status } = error.response;
      if (status === 403) {
        window.location.href = "/error/403";
      } else if (status === 404) {
        window.location.href = "/error/404";
      } else if (status === 500) {
        window.location.href = "/error/500";
      } else {
        if (status === 401) {
          if(window.location.pathname !== '/') {
            InitStorage();  // 스토어 삭제
            window.location.href = "/";
          }
        } else {
          window.location.href = "/error/500";
          ToastMsg('error', error?.message || "error connecting to server");
        }
      }
    } else {
      window.location.href = "/error/500";
      ToastMsg('error', error?.message || "error connecting to server");
    }
    return error;
  }
);

export const getCookie = (name) => {
	var cookieValue = null;
	if (document?.cookie) {
		var cookies = document.cookie.split(';');
		for (var i = 0; i < cookies.length; i++) {
			var cookie = cookies[i].replace(/^\s+|\s+$/g, "");
			if (cookie.substring(0, name.length + 1) === (name + '=')) {
				cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
				break;
			}
		}
	}
	return cookieValue;
}

/* Addition 객체 정의 */
export const Addition = {
	/** 커맨드 명 */
	cmdName: "",
	/** 현재페이지 */
	pageIndex: 1,
	/** 페이지갯수 */
	pageUnit: 10,
	/** 페이지사이즈 */
	pageSize: 10,
	/** 검색된 결과물 총 개수 */
	totalCnt: 0,
	/** 페이지 처리 여부 */
	pageYn: "N",
	/** firstIndex */
	firstIndex: 1,
	/** lastIndex */
	lastIndex: 1,
	/** recordCountPerPage */
	recordCountPerPage: 10
}

/* Param 객체 정의 */
export const Param = {
	paraName: "",
	paraValue: "",
}

/* ReqInputMsg 객체 정의 */
export const ReqInputMsg = (url, data) => {
  const urlArry = url.split('/');
  const addition = data?.length > 0 ? data[0] : {};
  const paramObj = data?.length > 1 ? (data[1] || {}) : {};
  const paramList = Object.keys(paramObj).map((key) => {
    return {
      paraName: key,
      paraValue: paramObj[key]
    }
  });
  const reqInputMsg = {
		addition : {
			...Addition,
      cmdName: urlArry?.length > 0 ? urlArry[urlArry?.length-1] : '',
			...addition
		},
		paramList
	}
  
  if(data?.length > 2) {
    const formData = new FormData();
    console.log(data)

    if (Array.isArray(data[2])) {
      data[2].forEach((file) => {
        formData.append("file", file); 
      });
    } else {
      formData.append("file", data[2]);
    }

    formData.append("reqInputMsg", JSON.stringify(reqInputMsg));
    return formData;
  }
  return JSON.stringify(reqInputMsg);
}

const get = (url, config) => {
  return instance.get(url, config);
}

const put = (url, data, config) => {
  return instance.put(url, data, config);
}

const patch = (url, data, config) => {
  return instance.patch(url, data, config);
}

const post = (url, data, config) => {
  return instance.post(url, JSON.stringify(data), config);
}

const callCmd = (url, data, config) => {
  return instance.post(url, ReqInputMsg(url, data), config);
}

// 엑셀 다운로드 바이너리 데이터 처리
const callCmdForFile = (url, data, config) => {
  return instance.post(url, ReqInputMsg(url, data), {
    ...config,
    responseType: 'blob'
  });
}

const request = {
  get,
  put,
  patch,
  post,

  callCmd,
  callCmdForFile,
};

export default request;